import { InventoryReportViewVO } from '../../../types/model/valueObject/InventoryReportViewVO';

import {SnackbarShowMessage} from "../../../context/snackbar-context";

export interface ModalType {
    open: boolean;
    type: string;
}

export interface DialogProps {
    open: boolean;
    asset: InventoryReportViewVO | null;
    onClose: () => void;
    account: {loggedInUsername: string};
    snackbarShowMessage: SnackbarShowMessage
}

export interface CheckoutDialogProps extends DialogProps {
    handleCheckout: (asset: any) => void;
    setImageDropZone: (item: any) => void;
    loading?: boolean;
}

export interface EditDialogProps extends DialogProps {
    handleEdit: (asset: any) => void;
}

export interface CheckOutAsset {
    id: string;
    bookingId: string;
    locationId: string;
    driverFirstName: string;
    driverLastName: string;
    driverLicenseNumber: string;
    truckLicensePlateNumber: string;
    notes: string;
    correlationId: string;
    checkOutUser: string;
    scacCode: string;
}

export interface EditAsset {
    id: string;
    locationId: string;
    containerNumber: string;
    chassisNumber: string;
    chassisLicensePlateNumber: string;
    sealNumber: string;
    driverFirstName: string;
    driverLastName: string;
    driverLicenseNumber: string;
    trailerNumber: string;
    truckLicensePlateNumber: string;
    notes: string;
    assetSize: string;
    assetType: string;
    scacCode: string;
}

export const modalTypes = {CHECKOUT: 'CHECKOUT', EDIT: 'EDIT'};
